import styled from "@emotion/styled";

export default styled.video``;
